<template>
  <p>
    <img
      :src="footerLogo"
      class="page-footer"
      :class="{ mobile: $route.meta.mobile }"
    />
  </p>
</template>

<script>
import { appIdentifier } from "@/utils/appIdentifier.js";
import constants from "@/utils/constants.js";
import footerLogo from "@/components/menus/pages/svg/icon-page-footer-logo.svg";
import footerLogoHuygens from "@/components/menus/pages/svg/icon-page-footer-logo-huygens.svg";
import footerLogoCanals5D from "@/components/menus/pages/svg/icon-page-footer-logo-canals5d.svg";

export default {
  computed: {
    footerLogo() {
      return appIdentifier() === constants.CANALS5D
        ? footerLogoCanals5D
        : appIdentifier() === constants.HUYGENS
          ? footerLogoHuygens
          : footerLogo;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-footer {
  width: 100%;
  display: block;
  margin: 0 auto;

  &.mobile {
    width: 100%;
  }
}
</style>
